<div [formGroup]="addBoxInterfaceToBoxForm" fxLayout="column">
  <div *ngIf="generalError" class="mat-error">
    {{generalError?.message}}
  </div>

  <mat-form-field>
    <mat-label>Box interfaces</mat-label>
    <mat-select [(value)]="selectedBoxInterfaces" formControlName="boxInterfaces" multiple name="boxInterfaces">
      <mat-option *ngIf="!loadingBoxInterfaces && filteredBoxInterfaces.length === 0">
        No box interfaces available.
      </mat-option>
      <mat-option *ngFor="let boxInterface of filteredBoxInterfaces" [value]="boxInterface">
        {{boxInterface?.name}}
      </mat-option>
    </mat-select>
    <span *ngIf="loadingBoxInterfaces" matPrefix><i class="fas fa-spinner fa-spin color-primary"></i>&nbsp;</span>
    <mat-hint *ngIf="!loadingBoxInterfaces && filteredBoxInterfaces.length === 0" class="color-warn">
      No box interfaces available.
    </mat-hint>
  </mat-form-field>


  <div fxLayout="row" fxLayoutAlign="end">
    <button (click)="box = _box; canceled.emit()" mat-button>Cancel</button>
    <button (click)="addBoxInterfaces()" [disabled]="addBoxInterfaceToBoxForm.invalid || saving " color="primary"
      mat-button>
      <i *ngIf="saving" class="fas fa-spinner fa-spin"></i>
      <ng-container *ngIf="!saving">Save</ng-container>
    </button>
  </div>

</div>